module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@3x-915584d1b12893c53a8ddb6d5a6b8032.png";